import React from 'react';
import styled from 'styled-components';
import { fontFamilyBold } from "../../../styling/mixins/typography";

const StyledCheckoutSectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.6rem;

  h4 {
    ${fontFamilyBold};
    text-transform: uppercase;
  }
`;

const CheckoutSectionHeader = ({ children, className = '' }) => {
  return (
    <StyledCheckoutSectionHeader className={`${className}`.trim()}>
      {children}
    </StyledCheckoutSectionHeader>
  );
};

export default CheckoutSectionHeader;
